module.exports = __webpack_public_path__ + "static/media/1006997.9c0bcc8c.jpg";